import comp from "./FilterHeader";

export default comp;
